import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft } from "react-feather";

function AddEdit_WalletTopup() {
  const API_URL_SAVE = "WalletTopup/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/VoucherForEdit/Id";
  const API_URL_MEMBER = `${API_WEB_URLS.MASTER}/0/token/DriverMemberMaster/Id/0`;
  const API_URL_LEDGER = `${API_WEB_URLS.MASTER}/0/token/BankCash/Id/0`;
  const API_URL_VOUCHERS = `${API_WEB_URLS.MASTER}/0/token/VoucherForEdit/Id/0`;

  const [state, setState] = useState({ id: 0, formData: { MemberId: "", FLedgerMaster: "", Amount: "" } });
  const [memberList, setMemberList] = useState([]);
  const [ledgerList, setLedgerList] = useState([]);
  const [voucherList, setVoucherList] = useState([]);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const amountRef = useRef(null);

  useEffect(() => {
    Fn_FillListData(dispatch, setMemberList, "gridData", API_URL_MEMBER);
    Fn_FillListData(dispatch, setLedgerList, "gridData", API_URL_LEDGER);
    Fn_FillListData(dispatch, setVoucherList, "gridData", API_URL_VOUCHERS);
    
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [dispatch, location.state]);

  const handleVoucherChange = (e) => {
    const selectedId = e.target.value;
    if (selectedId) {
      const selectedVoucher = voucherList.find(v => v.Id.toString() === selectedId.toString());
      if (selectedVoucher) {
        setState({
          id: selectedVoucher.Id,
          formData: {
            MemberId: selectedVoucher.MemberId,
            FLedgerMaster: selectedVoucher.FLedgerMaster,
            Amount: selectedVoucher.Amount
          }
        });
      }
    } else {
      setState({ id: 0, formData: { MemberId: "", FLedgerMaster: "", Amount: "" } });
    }
  };

  const validationSchema = Yup.object({
    MemberId: Yup.string().required("Driver ledger is required"),
    FLedgerMaster: Yup.string().required("Debit ledger is required"),
    Amount: Yup.number().required("Amount is required").positive("Amount must be positive"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    const obj = JSON.parse(localStorage.getItem("user"));
    let formData = new FormData();
    formData.append("Id", state.id || 0);
    formData.append("MemberId", values.MemberId || 0);
    formData.append("FLedgerMaster", values.FLedgerMaster || 0);
    formData.append("Amount", values.Amount || 0);
    formData.append("UserId", obj == null || obj === undefined ? 0 : obj.uid);
    
    Fn_AddEditData(dispatch, setState, { arguList: { id: 0, formData } }, API_URL_SAVE, true, "walletid", navigate, "/WalletTopup");
    resetForm();
    setState({ id: 0, formData: { MemberId: "", FLedgerMaster: "", Amount: "" } });
  };

  return (
    <div style={{ padding: "6px 8px", maxWidth: 900, margin: "0 auto" }}>
      <Card className="border shadow-none" style={{ marginBottom: 0 }}>
        <CardBody className="p-2" style={{ padding: "8px 12px !important" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, paddingBottom: 4, borderBottom: "1px solid #dee2e6" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Wallet Topup Voucher</span>
            <div style={{ display: "flex", gap: 6 }}>
              <Button type="button" size="sm" color="light" className="py-1 px-2" style={{ fontSize: 12 }} onClick={() => navigate("/WalletTopup")}>
                <ArrowLeft size={12} className="me-1" />Back
              </Button>
              <Button type="submit" form="wallet-form" size="sm" color="primary" className="py-1 px-2" style={{ fontSize: 12 }}>
                <Save size={12} className="me-1" />{state.id > 0 ? "Update" : "Save"}
              </Button>
            </div>
          </div>
          
          <Row style={{ marginBottom: 10, borderBottom: "1px dashed #dee2e6", paddingBottom: 10 }}>
            <Col xs={12} md={6}>
              <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Select Voucher to Edit (Optional)</label>
              <select className="form-select form-select-sm" style={{ height: 26, fontSize: 12 }} onChange={handleVoucherChange} value={state.id || ""}>
                <option value="">-- New Voucher --</option>
                {voucherList && voucherList.map((item) => (
                  <option key={item.Id} value={item.Id}>
                    Voucher #{item.VoucherNo || item.Id} - Rs. {item.Amount} ({item.DriverWalletLedgerName || `Driver Ledger: ${item.MemberId}`})
                  </option>
                ))}
              </select>
            </Col>
          </Row>

          <Formik 
            initialValues={{ 
              MemberId: state.formData.MemberId !== undefined && state.formData.MemberId !== null ? String(state.formData.MemberId) : "", 
              FLedgerMaster: state.formData.FLedgerMaster !== undefined && state.formData.FLedgerMaster !== null ? String(state.formData.FLedgerMaster) : "",
              Amount: state.formData.Amount || ""
            }} 
            validationSchema={validationSchema} 
            onSubmit={handleSubmit} 
            enableReinitialize={true}
          >
            {({ errors, touched }) => (
              <Form id="wallet-form" style={{ marginTop: 4 }}>
                <Row style={{ gap: "0 8px", rowGap: 2 }}>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Driver Ledger <span className="text-danger">*</span></label>
                    <Field as="select" className={`form-select form-select-sm ${errors.MemberId && touched.MemberId ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="MemberId">
                      <option value="">Select Driver Ledger</option>
                      {memberList && memberList.map((item) => (
                        <option key={item.Id} value={item.Id}>
                          {item.Name || item.LedgerName || item.Id}{item.MobileNo ? ` (${item.MobileNo})` : ""}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="MemberId" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Debit Ledger (Bank / Cash / Incentive) <span className="text-danger">*</span></label>
                    <Field as="select" className={`form-select form-select-sm ${errors.FLedgerMaster && touched.FLedgerMaster ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} name="FLedgerMaster">
                      <option value="">Select Debit Ledger (Bank / Cash / Incentive)</option>
                      {ledgerList && ledgerList.map((item) => <option key={item.Id} value={item.Id}>{item.Name || item.LedgerName || item.Id}</option>)}
                    </Field>
                    <ErrorMessage name="FLedgerMaster" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                  <Col xs={6} md={4} style={{ marginBottom: 4 }}>
                    <label style={{ fontSize: 11, fontWeight: 500, marginBottom: 1, display: "block" }}>Amount <span className="text-danger">*</span></label>
                    <Field innerRef={amountRef} className={`form-control form-control-sm ${errors.Amount && touched.Amount ? "is-invalid" : ""}`} style={{ height: 26, fontSize: 12 }} type="number" name="Amount" placeholder="Amount" />
                    <ErrorMessage name="Amount" component="div" style={{ fontSize: 10, color: "#dc3545" }} />
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </div>
  );
}

export default AddEdit_WalletTopup;
